var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavigationBar'),_c('router-view',{style:(_vm.isServices ? 'margin-top:6em' : 'margin-top:3em')})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }